import { render, staticRenderFns } from "./FooterApp.vue?vue&type=template&id=3ba68c06&"
import script from "./FooterApp.vue?vue&type=script&lang=js&"
export * from "./FooterApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports